import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-white/10" data-id="element-132">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-133">
        <p className="font-serif text-xl font-bold text-white mb-2" data-id="element-134">
          Pack Holístico
        </p>
        <p className="text-gray-500 text-xs" data-id="element-135">
          © {new Date().getFullYear()} Todos los derechos reservados. Este
          sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}